/**
 * Dependency Injection Module: Menu
 * Configures Inversify container for menu feature
 */

import { Container } from "inversify";
import type { IMenuRepository } from "../domain/repository/IMenuRepository";
import { MenuRepositoryImpl } from "../data/repository/MenuRepositoryImpl";
import { MenuApiService } from "../data/remote/service/MenuApiService";

const TYPES = {
  IMenuRepository: Symbol.for("IMenuRepository"),
};

const menuContainer = new Container();

menuContainer
  .bind<IMenuRepository>(TYPES.IMenuRepository)
  .to(MenuRepositoryImpl)
  .inSingletonScope();

menuContainer.bind(MenuApiService).toSelf().inSingletonScope();

export { menuContainer, TYPES };

